import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { TermsContent } from "@/components/TermsContent";
import { Loader2, Sparkles, LogOut } from "lucide-react";
import { toast } from "sonner";

export default function TermsGate() {
  const { acceptTerms, logout } = useAuth();
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setLoading(true);
    try {
      await acceptTerms();
      toast.success("Thanks — Terms accepted.");
    } catch (e) {
      toast.error("Could not save your acceptance. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-muted/30" data-testid="terms-gate">
      <header className="flex items-center justify-between border-b bg-background px-6 py-3.5">
        <div className="flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-md bg-primary">
            <Sparkles className="h-4.5 w-4.5 text-primary-foreground" />
          </div>
          <div>
            <div className="font-display text-lg font-extrabold leading-none">KlenaPro</div>
            <div className="label-caps text-muted-foreground">Terms &amp; Conditions</div>
          </div>
        </div>
        <Button variant="ghost" size="sm" onClick={logout} data-testid="terms-gate-logout" className="gap-2">
          <LogOut className="h-4 w-4" /> Sign out
        </Button>
      </header>

      <main className="mx-auto w-full max-w-3xl flex-1 px-6 py-8">
        <h1 className="font-display text-2xl font-extrabold">Please review and accept our Terms</h1>
        <p className="mt-1.5 text-sm text-muted-foreground">
          You need to accept the current Terms &amp; Conditions before you can continue using KlenaPro.
        </p>

        <div className="mt-6 max-h-[52vh] overflow-y-auto rounded-lg border bg-background p-5 sm:p-6">
          <TermsContent />
        </div>

        <label className="mt-5 flex items-start gap-3 text-sm" data-testid="terms-gate-checkbox-label">
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
            data-testid="terms-gate-checkbox"
            className="mt-0.5 h-4 w-4 accent-primary"
          />
          <span>I have read and agree to the KlenaPro Terms &amp; Conditions.</span>
        </label>

        <Button
          onClick={submit}
          disabled={!agreed || loading}
          data-testid="terms-gate-accept"
          className="k-press mt-5 h-11 w-full gap-2 text-base sm:w-auto sm:px-10"
        >
          {loading && <Loader2 className="h-4 w-4 animate-spin" />}
          Accept &amp; continue
        </Button>
      </main>
    </div>
  );
}
